import { api } from './api';

export interface Actividad {
  id: number;
  tenantId: number;
  tipo: 'llamada' | 'visita' | 'correo' | 'whatsapp' | 'reunion' | 'tarea' | 'nota';
  relacionTipo: 'lead' | 'cliente' | 'oportunidad';
  relacionId: number;
  titulo: string;
  descripcion?: string;
  fechaInicio?: string;
  fechaFin?: string;
  estado: 'pendiente' | 'en_proceso' | 'completada' | 'cancelada';
  resultado?: string;
  duracionMinutos?: number;
  usuarioAsignadoId: number;
  usuarioCreacionId: number;
  notas?: string;
  usuarioAsignado?: {
    id: number;
    name: string;
    email: string;
  };
  usuarioCreacion?: {
    id: number;
    name: string;
    email: string;
  };
  createdAt?: string;
  updatedAt?: string;
}

export interface ActividadCreate {
  tipo: 'llamada' | 'visita' | 'correo' | 'whatsapp' | 'reunion' | 'tarea' | 'nota';
  relacionTipo: 'lead' | 'cliente' | 'oportunidad';
  relacionId: number;
  titulo: string;
  descripcion?: string;
  fechaInicio?: string;
  fechaFin?: string;
  estado?: 'pendiente' | 'en_proceso' | 'completada' | 'cancelada';
  resultado?: string;
  duracionMinutos?: number;
  usuarioAsignadoId?: number;
  notas?: string;
}

export interface ActividadUpdate {
  titulo?: string;
  descripcion?: string;
  fechaInicio?: string;
  fechaFin?: string;
  estado?: 'pendiente' | 'en_proceso' | 'completada' | 'cancelada';
  resultado?: string;
  duracionMinutos?: number;
  usuarioAsignadoId?: number;
  notas?: string;
}

export interface PaginatedResponse<T> {
  data: {
    [key: string]: T[];
    pagination: {
      total: number;
      page: number;
      limit: number;
      totalPages: number;
    };
  };
}

export const actividadService = {
  getAll: async (
    page = 1,
    limit = 50,
    tipo?: string,
    relacionTipo?: string,
    relacionId?: number,
    estado?: string,
    usuarioAsignadoId?: number
  ): Promise<PaginatedResponse<Actividad>> => {
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString()
    });
    if (tipo) params.append('tipo', tipo);
    if (relacionTipo) params.append('relacionTipo', relacionTipo);
    if (relacionId) params.append('relacionId', relacionId.toString());
    if (estado) params.append('estado', estado);
    if (usuarioAsignadoId) params.append('usuarioAsignadoId', usuarioAsignadoId.toString());
    
    const response = await api.get<PaginatedResponse<Actividad>>(`/crm/actividades?${params}`);
    return response.data;
  },

  getById: async (id: number): Promise<{ data: { actividad: Actividad } }> => {
    const response = await api.get<{ data: { actividad: Actividad } }>(`/crm/actividades/${id}`);
    return response.data;
  },

  create: async (data: ActividadCreate): Promise<{ data: { actividad: Actividad } }> => {
    const response = await api.post<{ data: { actividad: Actividad } }>('/crm/actividades', data);
    return response.data;
  },

  update: async (id: number, data: ActividadUpdate): Promise<{ data: { actividad: Actividad } }> => {
    const response = await api.put<{ data: { actividad: Actividad } }>(`/crm/actividades/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<{ message: string }> => {
    const response = await api.delete<{ message: string }>(`/crm/actividades/${id}`);
    return response.data;
  }
};
